/** Ordered thumbnail URL candidates for an ASIN (first match usually wins in the browser). */
export function getAmazonProductImageCandidates(
  asin,
  marketplace = 'IN',
  preferredUrl = null
) {
  const normalized = asin?.trim?.()?.toUpperCase?.();

  if (!normalized) {
    return preferredUrl ? [preferredUrl] : [];
  }

  const regionalHost =
    marketplace === 'IN'
      ? 'https://images-eu.ssl-images-amazon.com'
      : 'https://images-na.ssl-images-amazon.com';
  const mediaHost = 'https://m.media-amazon.com';

  const patterns = [
    `${regionalHost}/images/P/${normalized}.01._SL75_.jpg`,
    `${mediaHost}/images/P/${normalized}.01._SL75_.jpg`,
    `${regionalHost}/images/P/${normalized}.02._SL75_.jpg`,
    `${mediaHost}/images/P/${normalized}.02._SL75_.jpg`,
    `${regionalHost}/images/P/${normalized}.01._SL150_.jpg`,
    `${mediaHost}/images/P/${normalized}.01._SL150_.jpg`,
    `${regionalHost}/images/P/${normalized}.03._SL75_.jpg`,
    `${mediaHost}/images/P/${normalized}.03._SL75_.jpg`,
    `${regionalHost}/images/P/${normalized}._SL75_.jpg`,
    `${mediaHost}/images/P/${normalized}._SL75_.jpg`,
  ];

  const candidates = preferredUrl ? [preferredUrl, ...patterns] : patterns;
  return [...new Set(candidates.filter(Boolean))];
}

export function getAmazonProductImageUrl(asin, marketplace = 'IN') {
  return getAmazonProductImageCandidates(asin, marketplace)[0] || null;
}

export function resolveOrderItemImageUrl(item, marketplace) {
  const asin = item?.asinIn || item?.asinCom;
  const resolvedMarketplace =
    marketplace || (item?.asinIn ? 'IN' : item?.asinCom ? 'US' : 'IN');

  return getAmazonProductImageUrl(asin, resolvedMarketplace);
}
